"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _Pagination = _interopRequireDefault(require("../Pagination"));
var _meta = require("../_utils/meta");
var _links = require("../_utils/links");
var _errorMessages = require("../_utils/error-messages");
var _assets = require("../_utils/assets");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    mainHeading: {
      marginTop: '0 !important',
      marginBottom: '16px !important'
    },
    linkList: _objectSpread({}, theme.mixins.noList),
    listItem: {
      width: '100%',
      marginBottom: theme.spacing(4),
      '&.disabled': {
        marginBottom: 0,
        height: 0,
        overflow: 'hidden',
        visibility: 'hidden'
      }
    },
    title: _objectSpread({}, theme.mixins.limitLines(2)),
    description: _objectSpread(_objectSpread({}, theme.mixins.limitLines(3)), {}, {
      marginBottom: '0 !important'
    }),
    pagination: {
      marginBottom: theme.spacing(10)
    }
  };
});
var RelatedProductResourcesEditConfig = {
  emptyLabel: 'Configure Related Product Resources',
  isEmpty: function isEmpty(props) {
    return !props || !props.relatedProductResources || props.relatedProductResources.length < 1;
  }
};
var RelatedProductResources = function RelatedProductResources(_ref) {
  var headline = _ref.headline,
    relatedProductResources = _ref.relatedProductResources,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 5 : _ref$pageSize,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      page: 'Page',
      pagination: 'Page {page} of {numberOfPages}',
      goNext: 'Go to next page',
      goPrevious: 'Go to previous page'
    } : _ref$translations;
  var _useState = (0, _react.useState)(1),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  var _useState2 = (0, _react.useState)(relatedProductResources),
    relatedProductData = _useState2[0],
    setRelatedProductData = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    assetsModels = _useState3[0],
    setAssetsModels = _useState3[1];
  var _useState4 = (0, _react.useState)([]),
    errorsFound = _useState4[0],
    setErrorsFound = _useState4[1];
  var classes = useStyles();
  var handleUpdatePage = function handleUpdatePage(number) {
    return setCurrentPage(number);
  };
  var range = function range(num) {
    var aux = pageSize * currentPage;
    return num >= aux - pageSize && num <= aux - 1;
  };

  // Filter assets without configured title or description and returns a list of assets URL
  var assetsPath = relatedProductResources.reduce(function (previousValue, link) {
    if ((0, _assets.isAsset)(link.linkURL) && (!link.pageTitle || !link.pageDescription)) {
      previousValue.push(link.linkURL);
    }
    return previousValue;
  }, []);
  (0, _react.useEffect)(function () {
    setRelatedProductData(relatedProductResources)

    // Using an IIFE to use async
    ;
    (function () {
      var _anyNameFunction = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var assets;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _assets.getAssetsModel)(assetsPath);
              case 2:
                assets = _context.sent;
                setAssetsModels(assets);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function anyNameFunction() {
        return _anyNameFunction.apply(this, arguments);
      }
      return anyNameFunction;
    })()();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relatedProductResources]);

  // Update relatedProductData when we get the assets models
  (0, _react.useEffect)(function () {
    var errors = [];
    setRelatedProductData(function (prevState) {
      var newState = prevState.map(function (link) {
        var position = assetsPath.indexOf(link.linkURL);
        if (position >= 0) {
          var json = assetsModels === null || assetsModels === void 0 ? void 0 : assetsModels[position];
          var jsonTitle = json === null || json === void 0 ? void 0 : json['ms:documentTitle'];
          var jsonDescription = json === null || json === void 0 ? void 0 : json['ms:description'];
          var newObj = {};
          if (!jsonTitle && !link.pageTitle) {
            errors.push(link.linkURL);
          }
          if (!link.pageTitle && jsonTitle) {
            newObj['pageTitle'] = jsonTitle;
          }
          if (!link.pageDescription && jsonDescription) {
            newObj['pageDescription'] = jsonDescription;
          }
          return _objectSpread(_objectSpread({}, link), newObj);
        }
        return link;
      });
      return newState;
    });
    setErrorsFound(errors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsModels]);
  var displayMissingContent = function displayMissingContent() {
    if (errorsFound.length > 0) {
      var numErrors = errorsFound.length;
      var errorMessage = (0, _errorMessages.listedErrors)(numErrors, errorsFound);
      return __jsx(_react.default.Fragment, null, errorMessage);
    }
    return null;
  };
  var products = relatedProductData.filter(function (link, index) {
    return errorsFound.indexOf(link.linkURL) === -1;
  });
  var isPaginationNeeded = products.length / pageSize > 1;
  return __jsx("div", null, headline && __jsx("h2", {
    className: classes.mainHeading,
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), isAemEditMode && displayMissingContent(), __jsx("ul", {
    className: classes.linkList
  }, products.map(function (link, index) {
    var linkProps = (0, _links.getTarget)(link.linkURL);
    return __jsx("li", {
      key: index,
      className: (0, _clsx.default)(classes.listItem, {
        disabled: !range(index)
      })
    }, __jsx("a", (0, _extends2.default)({
      className: classes.title,
      href: link.linkURL
    }, linkProps, {
      dangerouslySetInnerHTML: {
        __html: link.pageTitle || link.linkURL
      }
    })), link.pageDescription && __jsx("p", {
      className: classes.description,
      dangerouslySetInnerHTML: {
        __html: link.pageDescription
      }
    }));
  })), isPaginationNeeded && __jsx("div", {
    className: classes.pagination
  }, __jsx(_Pagination.default, {
    totalCount: products.length,
    pageSize: pageSize,
    onPageChange: handleUpdatePage,
    translations: translations
  })));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedproductresources')(RelatedProductResources, RelatedProductResourcesEditConfig);
exports.default = _default;